import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { BASE_URL, TOKEN, URL } from "./Constants";
import { TOKEN } from "./Constants";
import { BASE_URL, URL } from "../../../Services/Constant";

export const api = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      const token = localStorage.getItem(TOKEN);

      headers.set("Authorization", "Bearer " + token);
      // headers.set("Content-Type", "multipart/form-data");
      // headers.set("Content-Type", "application/json");
      headers.set("Accept", "application/json");
    },
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: [],
  endpoints: (builder) => ({
    // LOGIN
    login: builder.mutation({
      query: (payload) => ({
        url: URL.LOGIN,
        body: payload,
        method: "POST",
      }),
    }),

    // LOGOUT
    logout: builder.query({
      query: () => URL.LOGOUT,
    }),
    // COMPANY LOGOUT
    companyLogout: builder.query({
      query: () => URL.COMPANY_LOGOUT,
    }),

    //FORGOT PASSWORD
    forgotPassword: builder.mutation({
      query: (payload) => ({
        url: URL.FORGOT_PASSWORD,
        body: payload,
        method: "POST",
      }),
    }),

    //VERIFY TOKEN
    verifyToken: builder.query({
      query: (id) => URL.TOKEN_VERIFY + id,
    }),

    //SET PASSWORD
    changePassword: builder.mutation({
      query: (payload) => ({
        url: URL.CHANGE_PASSWORD,
        body: payload,
        method: "POST",
      }),
    }),

    //ADMIN

    addAdmin: builder.mutation({
      query: (payload) => ({
        url: URL.ADD_ADMIN,
        body: payload,
        method: "POST",
      }),
    }),
    addAdminCompany: builder.mutation({
      query: (payload) => ({
        url: URL.ADMIN_ADD_COMPANY,
        body: payload,
        method: "POST",
      }),
    }),
    updateAdmin: builder.mutation({
      query: (payload) => ({
        url: URL.UPDATE_ADMIN,
        body: payload,
        method: "POST",
      }),
    }),

    updateAdminCompany: builder.mutation({
      query: (payload) => ({
        url: URL.ADMIN_EDIT_COMPANY,
        body: payload,
        method: "POST",
      }),
    }),

    viewAdmin: builder.query({
      query: (id) => URL.VIEW_ADMIN + id,
    }),

    viewAdminCompany: builder.query({
      query: (id) => URL.ADMIN_VIEW_COMPANY + id,
    }),

    deleteAdmin: builder.query({
      query: (id) => URL.DELETE_ADMIN + id,
    }),

    deleteAdminCompany: builder.mutation({
      query: (id) => ({
        url: URL.ADMIN_DELETE_COMPANY + id,
        body: {},
        method: "POST",
      }),
    }),

    adminStatus: builder.query({
      query: (id) => URL.ADMIN_STATUS + id,
    }),

    adminStatusCompany: builder.query({
      query: (id) => URL.ADMIN_STATUS_CHANGE + id,
    }),

    listAdmin: builder.mutation({
      query: (payload) => ({
        url: URL.LIST_ADMIN,
        body: payload,
        method: "POST",
      }),
    }),

    listCompanyAdmin: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_ADMIN_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    //ROLE

    permissionsList: builder.query({
      query: () => URL.PERMISSIONS_LIST,
    }),
    subadminPermissionsList: builder.query({
      query: () => URL.SUBADMIN_PERMISSIONS_LIST,
    }),

    listRole: builder.mutation({
      query: (payload) => ({
        url: URL.ROLE_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    addRole: builder.mutation({
      query: (payload) => ({
        url: URL.ADD_ROLE,
        body: payload,
        method: "POST",
      }),
    }),

    updateRole: builder.mutation({
      query: (payload) => ({
        url: URL.UPDATE_ROLE,
        body: payload,
        method: "POST",
      }),
    }),

    viewRole: builder.query({
      query: (id) => URL.VIEW_ROLE + id,
    }),
    viewSubadminRole: builder.query({
      query: (id) => URL.SUBADMIN_ROLES_VIEW + id,
    }),

    deleteRole: builder.query({
      query: (id) => URL.DELETE_ROLE + id,
    }),
    roleStatus: builder.query({
      query: (id) => URL.ROLE_STATUS + id,
    }),

    // Company lists
    companyList: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    companyAdd: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_ADD,
        body: payload,
        method: "POST",
      }),
    }),
    adminCompanyView: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.ADMIN_COMPANY_VIEW + ID + "/user-lists",
        body: payload,
        method: "POST",
      }),
    }),
    companyEdit: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.COMPANY_EDIT + ID,
        body: payload,
        method: "POST",
      }),
    }),

    companyRolesList: builder.query({
      query: () => URL.COMPANY_ROLE_LIST,
    }),

    companyStatus: builder.query({
      query: (id) => URL.COMPANY_STATUS + id,
    }),
    companyListView: builder.query({
      query: (id) => URL.COMPANY_List_VIEW + id,
    }),

    companyDelete: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_DELETE + payload,
        method: "DELETE",
      }),
    }),

    // Company Devices

    companyDeviceList: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_DEVICES,
        body: payload,
        method: "POST",
      }),
    }),
    companyDeviceEdit: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.COMPANY_DEVICES_EDIT + ID,
        body: payload,
        method: "POST",
      }),
    }),
    companyDeviceStatus: builder.query({
      query: (id) => URL.COMPANY_DEVICES_STATUS + id,
    }),

    // Company device view
    companyDevicesView: builder.query({
      query: (id) => URL.COMPANY_DEVICES_VIEW + id,
    }),
    // Company Manager
    companyManager: builder.query({
      query: () => URL.COMPANY_MANAGER,
    }),

    companyManagerEdit: builder.mutation({
      query: (payload) => ({
        url: URL.COMPANY_MANAGER_EDIT,
        body: payload,
        method: "POST",
      }),
    }),
    companyLocationList: builder.query({
      query: () => URL.COMPANY_LOCATION,
    }),
    subadminRolesList: builder.query({
      query: () => URL.SUBADMIN_ROLES,
    }),

    //profile  subadmin
    subAdminList: builder.mutation({
      query: (payload) => ({
        url: URL.SUBADMIN_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    subAdminAdd: builder.mutation({
      query: (payload) => ({
        url: URL.SUBADMIN_ADD,
        body: payload,
        method: "POST",
      }),
    }),
    subAdminEdit: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.SUBADMIN_EDIT + ID,
        body: payload,
        method: "POST",
      }),
    }),
    subadminView: builder.query({
      query: (id) => URL.SUBADMIN_VIEW + id,
    }),
    subadminStatus: builder.query({
      query: (id) => URL.SUBADMIN_STATUS + id,
    }),

    profileUserList: builder.mutation({
      query: (payload) => ({
        url: URL.PROFILE_USER_LIST,
        body: payload,
        method: "POST",
      }),
    }),
    membersList: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.MEMBERS_LIST + ID + "/assigned-users",
        body: payload,
        method: "POST",
      }),
    }),
    membersAdd: builder.mutation({
      query: ({ payload, ID }) => ({
        url: URL.MEMBERS_LIST_ADD + ID,
        body: payload,
        method: "POST",
      }),
    }),
    membersCheck: builder.mutation({
      query: (payload) => ({
        url: URL.CHECK_MEMBERS,
        body: payload,
        method: "POST",
      }),
    }),

    //USER LIST

    listUser: builder.mutation({
      query: (payload) => ({
        url: URL.USER_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    addUser: builder.mutation({
      query: (payload) => ({
        url: URL.ADD_USER,
        body: payload,
        method: "POST",
      }),
    }),

    updateUser: builder.mutation({
      query: (payload) => ({
        url: URL.UPDATE_USER,
        body: payload,
        method: "POST",
      }),
    }),

    viewUser: builder.query({
      query: (id) => URL.VIEW_USER + id,
    }),

    userStatus: builder.query({
      query: (id) => URL.USER_STATUS + id,
    }),

    //DEVICE LIST

    deviceList: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    deviceUserList: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_USER_LIST,
        body: payload,
        method: "POST",
      }),
    }),

    addDevice: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_ADD,
        body: payload,
        method: "POST",
      }),
    }),

    updateDevice: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_UPDATE,
        body: payload,
        method: "POST",
      }),
    }),

    deviceReport: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_REPORT,
        body: payload,
        method: "POST",
      }),
    }),
    subadmindeviceReport: builder.mutation({
      query: (payload) => ({
        url: URL.SUBADMIN_DEVICE_REPORT,
        body: payload,
        method: "POST",
      }),
    }),
    deviceReportExport: builder.mutation({
      query: (payload) => ({
        url: URL.DEVICE_REPORT_EXPORT,
        body: payload,
        method: "POST",
      }),
    }),

    notificationReport: builder.mutation({
      query: (payload) => ({
        url: URL.NOTIFICATION_REPORT,
        body: payload,
        method: "POST",
      }),
    }),
    subadminNotificationReport: builder.mutation({
      query: (payload) => ({
        url: URL.SUBADMIN_NOTIFICATION_REPORT,
        body: payload,
        method: "POST",
      }),
    }),
    notificationReportExport: builder.mutation({
      query: (payload) => ({
        url: URL.NOTIFICATION_REPORT_EXPORT,
        body: payload,
        method: "POST",
      }),
    }),

    viewDevice: builder.query({
      query: (id) => URL.DEVICE_VIEW + id,
    }),

    DeviceStatus: builder.query({
      query: (id) => URL.DEVICE_STATUS + id,
    }),

    //LOCATION

    locationList: builder.query({
      query: () => URL.LOCATION_LIST,
    }),

    locationStatus: builder.query({
      query: (id) => URL.LOCATION_STATUS + id,
    }),

    // MANUAL TRIGGER
    manualTrigger: builder.query({
      query: (id) => URL.MANUAL_TRIGGER + id,
    }),

    // Lighting TRIGGER
    lightTrigger: builder.query({
      query: (id) => URL.CALCULATE_DISTANCE + id,
    }),

    // LOG LIST
    logList: builder.query({
      query: () => ({
        url: URL.LOG_FILE,
        method: "GET",
      }),
    }),

    // Log date filter
    logFilter: builder.query({
      query: (date) => ({
        url: URL.LOG_FILE + date,
        method: "GET",
      }),
    }),
  }),
});

export const {
  //AUTHENTICATION
  useLoginMutation,
  useLazyLogoutQuery,
  useForgotPasswordMutation,
  useLazyVerifyTokenQuery,
  useChangePasswordMutation,

  //ADMIN
  useAddAdminMutation,
  useLazyViewAdminQuery,
  useListAdminMutation,
  useListCompanyAdminMutation,
  useLazyAdminStatusQuery,
  useLazyDeleteAdminQuery,
  useUpdateAdminMutation,
  useAddAdminCompanyMutation,
  useUpdateAdminCompanyMutation,
  useDeleteAdminCompanyMutation,
  useLazyAdminStatusCompanyQuery,
  useLazyViewAdminCompanyQuery,

  //ROLE
  useLazyPermissionsListQuery,
  useListRoleMutation,
  useAddRoleMutation,
  useUpdateRoleMutation,
  useLazyViewRoleQuery,
  useLazyDeleteRoleQuery,
  useLazyRoleStatusQuery,
  useLazyViewSubadminRoleQuery,
  useLazySubadminPermissionsListQuery,
  useLazySubadminRolesListQuery,

  // company
  useCompanyAddMutation,
  useCompanyListMutation,
  useLazyCompanyRolesListQuery,
  useLazyCompanyStatusQuery,
  useCompanyDeleteMutation,
  useCompanyEditMutation,
  useLazyCompanyListViewQuery,
  useLazyCompanyLogoutQuery,
  useLazyCompanyLocationListQuery,
  useAdminCompanyViewMutation,

  // CompanyDevices
  useCompanyDeviceListMutation,
  useLazyCompanyDevicesViewQuery,
  useCompanyDeviceEditMutation,
  useLazyCompanyDeviceStatusQuery,

  // companyManager
  useLazyCompanyManagerQuery,
  useCompanyManagerEditMutation,

  // subadmin
  useSubAdminListMutation,
  useSubAdminAddMutation,
  useLazySubadminViewQuery,
  useSubAdminEditMutation,
  useLazySubadminStatusQuery,
  // profile users
  useProfileUserListMutation,
  useMembersCheckMutation,
  useMembersAddMutation,
  useMembersListMutation,

  //USER LIST
  useListUserMutation,
  useAddUserMutation,
  useUpdateUserMutation,
  useLazyViewUserQuery,
  useLazyUserStatusQuery,

  //DEVICE LIST
  useDeviceListMutation,
  useAddDeviceMutation,
  useUpdateDeviceMutation,
  useLazyViewDeviceQuery,
  useLazyDeviceStatusQuery,
  useDeviceUserListMutation,
  useDeviceReportMutation,
  useSubadmindeviceReportMutation,
  useSubadminNotificationReportMutation,
  useDeviceReportExportMutation,
  useNotificationReportMutation,
  useNotificationReportExportMutation,

  //LOCATION
  useLazyLocationListQuery,
  useLazyLocationStatusQuery,

  // MANUAL TRIGGER
  useLazyManualTriggerQuery,
  useLazyLightTriggerQuery,

  //LOG FILE
  useLazyLogListQuery,
  useLazyLogFilterQuery,
} = api;
